"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortOptions = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var RadioButton_1 = require("../../atoms/RadioButton");
var Legend_1 = require("../../atoms/Legend");
exports.SortOptions = react_1.default.memo(function (_a) {
    var _b = _a.legend, legend = _b === void 0 ? 'sort by' : _b, idPrefix = _a.idPrefix, sortLabel = _a.sortLabel, direction = _a.direction, onChange = _a.onChange;
    var _c = (0, react_1.useState)({
        direction: direction,
    }), state = _c[0], setState = _c[1];
    var handleSort = function (event, sortDirection) {
        var update = __assign(__assign({}, state), { direction: sortDirection });
        setState(update);
        onChange(event, update);
    };
    var label = "".concat(sortLabel || '', " ");
    return ((0, jsx_runtime_1.jsxs)(core_1.Box, __assign({ role: "group", flexDirection: "column", display: "flex", "data-testid": "sort-options" }, { children: [(0, jsx_runtime_1.jsx)(Legend_1.Legend, { children: legend }), (0, jsx_runtime_1.jsx)(RadioButton_1.RadioButton, { role: "menuitemradio", name: "FilterSortDirection", id: "".concat(idPrefix, "SortAscCheckbox"), label: "".concat(label, "(Ascending)"), onChange: function (event) { return handleSort(event, 'asc'); }, checked: state.direction === 'asc' }), (0, jsx_runtime_1.jsx)(RadioButton_1.RadioButton, { role: "menuitemradio", name: "FilterSortDirection", id: "".concat(idPrefix, "SortDescCheckbox"), label: "".concat(label, "(Descending)"), onChange: function (event) { return handleSort(event, 'desc'); }, checked: state.direction === 'desc' })] })));
});
